import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form } from 'antd';
import PromoForm from './PromoForm';

class EditPromoModal extends Component {
  onOk = (e) => {
    if (typeof this.props.onOk === 'function') {
      this.props.onOk(e);
      return;
    }

    const form = this.props.form;
    if (typeof form.resetFields === 'function') {
      form.resetFields();
    }
  };

  render = () => {
    const { onCancel, visible, form, promo } = this.props;

    return (
      <Modal title="Edit Promotion" visible={visible} onCancel={onCancel} onOk={this.onOk}>
        <PromoForm form={form} promo={promo} />
      </Modal>
    );
  };
}

EditPromoModal.proptypes = {
  onOk: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

const ModalForm = Form.create()(EditPromoModal);

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/Promo/EditPromoModal.js